export default {
  // ========== Mensajes de advertencia ==========
  noHoursAssignedPrefix: 'No hay horas pedagógicas asignadas a la',
  noHoursAssignedSuffix: 'por lo que no se generan sesiones automáticamente. Configura las horas en el',
  outOfSpecMessage: 'Las sesiones que se listan a continuación ya existían y están fuera de lo especificado en la asignatura.',

  // ========== Cabeceras de tabla ==========
  session: 'Sesión',
  whatWillStudentLearn: '¿QUÉ VA A APRENDER EL ESTUDIANTE?',
  howWillTheyLearnIt: '¿CÓMO LO VA A APRENDER?',
  howWillTheyPracticeIt: '¿CÓMO LO EJERCITARÁ?',
  sessionObservationsTitle: 'OBSERVACIONES DE LA SESIÓN UNA VEZ REALIZADA LA CLASE',
  obs: 'OBS',
  classroomActivities: 'ACTIVIDADES EN AULA',
  basicBibliography: 'BIBLIOGRAFÍA BÁSICA',
  associatedEvaluation: '(ACTIVIDAD/EVALUACIÓN) ASOCIADA',

  // ========== Observaciones del docente ==========
  teacherObservations: 'Observaciones del Docente',
  observationsOfThe: 'Observaciones de la',
};
